// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';

import { validateBankName } from './bank-name';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'selectedEftBank') {
    return onlyWhen('field_colombian_bank_list') && validateBankName(userInputValue);
  }

  return undefined;
}
